import IconTooltip from "@/components/IconTooltip";

export default function Amenities({ amenities }) {
    const iconMap = {
        "restroom": "restroom",
        "information - maps available": "map",
        "theater/auditorium": "masks-theater",
        "historical/interpretive information/exhibits": "landmark",
        "gifts/souvenirs/books": "gift",
        "cellular signal": "signal",
        "captioned media": "closed-captioning",
        "benches/seating": "chair",
        "information": "circle-info",
        "information - ranger/staff member present": "person",
        "information kiosk/bulletin board": "thumbtack",
        "parking - auto": "square-parking",
        "wheelchair accessible": "wheelchair",
        "atm/cash machine": "money-check-dollar",
        "accessible rooms": "universal-access",
        "accessible sites": "universal-access",
        "animal-safe food storage": "vault",
        "assistive listening systems": "ear-listen",
        "trailhead": "person-hiking",
        "pets allowed": "paw",
        "trash/litter receptacles": "trash",
        "grill": "burger",
        "permits issued": "file-circle-check",
        "water - bottle-filling station": "glass-water-droplet",
        "food/drink - ice cream": "ice-cream",
        "internet/wifi available": "wifi",
        "water - drinking/potable": "droplet",
        "toilet - flush": "toilet",
        "parking - bus/rv": "caravan",
        "restroom - family": "restroom",
        "junior ranger booklet available": "book",
        "automated entrance": "door-open",
        "beach/water access": "umbrella-beach",
        "bus/shuttle stop": "van-shuttle",
        "canoe/kayak/small boat launch": "ship",
        "dock/pier": "bridge-water",
        "elevator": "elevator",
        "entrance passes for sale": "ticket-simple",
        "food/drink - restaurant/table service": "utensils",
        "food/drink - snacks": "cookie-bite",
        "hitching post/corral": "hat-cowboy-side",
        "restroom - accessible": "wheelchair",
        "scenic view/photo spot": "panorama",
        "showers": "shower",
        "ticket sales": "ticket",
        "baby changing station": "baby",
        "bicycle - rental": "person-biking",
        "fire pit": "fire",
        "first aid kit available": "kit-medical",
        "first aid/medical care available": "bandage",
        "fish-cleaning station": "fish",
        "food/drink - cafeteria": "apple-whole",
        "fuel (unleaded)": "gas-pump",
        "information - park newspaper available": "newspaper",
        "sewage dump station - boat/rv": "caravan",
        "telephone": "square-phone"
    };
    return(
        <>
            <ul className={`grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3`}>
                {amenities.map((amenity) =>
                    iconMap[amenity.name.toLowerCase()] ?
                        <li key={amenity.id} className={`col-span-1 flex`}>
                            <i className={`fa fa-${iconMap[amenity.name.toLowerCase()]} text-xl text-brown-300`} aria-hidden="true" />
                            {/*<IconTooltip icon={iconMap[amenity.name.toLowerCase()]} name={amenity.name} size={`text-xl`} color={`text-brown-300`}/>*/}
                            <span className={`text-sm ml-4`}>{amenity.name}</span>
                        </li>
                        : null
                )}
            </ul>
        </>
    )
}